import * as PopperJS from '@popperjs/core';
import classNames from 'classnames';
import { FC } from 'react';

import customScrollStyles from '../../CustomScroll/CustomScroll.styles.m.css';
import { Popover } from '../../Popover/Popover';
import { ISelectorMenuItem } from '../Selector.types';
import { SelectorItem } from '../SelectorItem/SelectorItem';
import styles from './SelectorMenu.styles.m.css';

interface ISelectorMenuProps<K extends string = string> {
  menuClassName?: string;
  onClose(): void;
  isOpened: boolean;
  menuItems: ISelectorMenuItem<K>[];
  reference: HTMLElement | null;
  placement?: PopperJS.Placement;
  isFullWidth?: boolean;
}

export const SelectorMenu: FC<ISelectorMenuProps> = (props) => {
  const {
    onClose,
    isOpened,
    menuItems,
    reference,
    placement = 'bottom-start',
    isFullWidth,
  } = props;

  const close = (): void => {
    onClose?.();
  };
  return (
    <Popover
      modifiers={[
        {
          name: 'offset',
          options: { offset: [0, 0] },
        },
      ]}
      className={styles.container}
      isOpened={isOpened}
      onClose={close}
      reference={reference}
      placement={placement}
      isFullWidth={isFullWidth}
    >
      <div className={classNames(styles.menu, customScrollStyles.container)}>
        {menuItems.map((item) => (
          <SelectorItem
            item={item}
            key={item.key}
          />
        ))}
      </div>
    </Popover>
  );
};
